export default {
  todayIncome: 'Today\'s Income',
  appointmentToday: 'Today\'s Appointments',
  totalPatients: 'Total Patients',
  averagePatientAge: 'Average Patient Age',
  popularTreatments: 'Popular Treatments (times)',
  product: 'Product',
  bestSellingProducts: 'Best-Selling Products',
  totalTreatments: 'Total Treatment Revenue (Baht)',
  totalSellingProduct: 'Total Product Sales (Baht)',
  treatment: 'Treatment',
  admissionDate: 'Admission Date',
  total: 'Total Usage',
  totalSale: 'Total Sold',
  productName: 'Product Name',
  todayCash: 'Today\'s Cash',
  todayTranfer: 'Today\'s Transfers',
  todayCredit: 'Today\'s Credit Card',
  todayCashBack: 'Today\'s Refunds',
  todayOrder: 'Today\'s Orders',
  cutOffDate: 'Cut-Off Date',
  aboutToExpire: 'About to Expire',
  remainingCredit: 'Remaining Credit',
  contactAdmin: 'Contact Admin',
  bath: 'Baht',
  list: 'Items',
  appointment: 'Appointment',
  person: 'Person',
  years: 'Years'
}
